/**
 * Created by Alican Köker on 2019-03-14.
 */
import { ReelAreaView } from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import { IResizeData } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { Orientation } from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import { EdisonGameConfig } from "../EdisonGameConfig";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { TimelineLite } from "gsap";
import { EdisonIndividualWPView } from "../winpresentation/individual/EdisonIndividualWPView";
import { ServerEvent } from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import { EdisonParsedInitData } from "../server/data/EdisonParsedInitData";
import { EdisonParsedGameData } from "../server/data/EdisonParsedGameData";

export class EdisonReelAreaView extends ReelAreaView {

    public static readonly SET_ORIENTATION:string = "edisonReelAreaView_setOrientation";
    public static readonly ANIMATE_MODE_SET:string = "edisonReelAreaView_animateModeSet";
    private _yGapPortrait:number = 0;
    private _yValue:number = 0;
    private _orientation:Orientation;
    protected _currentMode:string;
    protected _nextMode:string;
    private _isRestore:boolean = false;
    private _initResize:boolean = true;
    private _modeChangeAnimTimeline:TimelineLite;

    constructor() {
        super();
        EventHandler.addEventListener(this, EdisonIndividualWPView.SET_MODE, (event:GameEvent) => this.nextMode = event.params[0]);
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected onGameDataParsed(data:EdisonParsedGameData):void {
        this._isRestore = false;
    }

    protected onInitDataParsed(data:EdisonParsedInitData):void {
        this._isRestore = data.isRestoreState;
        this._currentMode = data.nextMode;
    }

    private set nextMode(mode:string) {
        if(this._nextMode === mode)
            return;

        this._nextMode = mode;
    }

    private set currentMode(mode:string) {
        if(this._currentMode === mode)
            return;

        this._currentMode = mode;
    }

    protected onResize(resizeData:IResizeData):void {
        if(this._orientation === resizeData.orientation && !this._initResize) {
            return;
        }

        this._initResize = false;

        EventHandler.dispatchEvent(new GameEvent(EdisonReelAreaView.SET_ORIENTATION, resizeData));

        if(this._modeChangeAnimTimeline && this._modeChangeAnimTimeline.isActive()) {
            this._modeChangeAnimTimeline.pause();
            this._modeChangeAnimTimeline.kill();
            this.currentMode = this._nextMode;
        }

        this._orientation = resizeData.orientation;
        this._yValue = this._orientation === Orientation.LANDSCAPE ? EdisonGameConfig.instance.REEL_AREA_POS_Y : EdisonGameConfig.instance.REEL_AREA_POS_Y_PORTRAIT;

        this.position.set(EdisonGameConfig.instance.REEL_AREA_POS_X, this._yValue + this._yGapPortrait);

        this._reelViews.forEach((reelView:PIXI.Container, reelId:number) => {
            this.updateReelViewPosition(reelView, reelId);
        });

        this.UpdateReelAreaMask();
    }

    protected UpdateReelAreaMask():void {
        super.UpdateReelAreaMask();
    }
}